import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link, Redirect} from 'react-router-dom';
import {Button, Divider, Form, Header} from 'semantic-ui-react';
import {clearError, getError, isBusy, withActions} from 'actionware';
import produce from 'immer';

import {FormattedMessage} from '../i18n/Context';
import {login} from '../../store/identity';
import AppFooter from '../layout/AppFooter';
import {FormWrapper, Wrapper} from './Layout';
import {ErrorMessages} from '../form-components/ErrorMessages';

export class LogIn extends Component {
  state = {
    emailAddress: '',
    password: '',
  };

  componentDidMount() {
    clearError(login);
  }

  _mutateState = mutationFn => {
    this.setState(produce(mutationFn));
  };
  _handleInputChanged = (event, {name, value}) => {
    this._mutateState(state => {
      state[name] = value;
    });
  };

  render() {
    const {
      loading,
      error,
      user,
      location: {state = {}},
      login,
    } = this.props;
    const {emailAddress, password} = this.state;
    const pathname =
      state.from && state.from.pathname ? state.from.pathname : '/';

    return (
      <Wrapper>
        <Header textAlign="center">
          <img
            src={`${process.env.PUBLIC_URL}/mm_logo.png`}
            alt="M&M International"
          />
        </Header>
        <FormWrapper attached loading={loading}>
          <Header textAlign="center">
            <FormattedMessage id="login.header" />
          </Header>
          <Form
            onSubmit={() => {
              login({emailAddress, password}).catch(() => {
              });
            }}
          >
            <Form.Field>
              <label>
                <FormattedMessage id="login.form.emailAddress" />
              </label>
              <Form.Input
                type="email"
                name="emailAddress"
                value={emailAddress}
                onChange={this._handleInputChanged}
                autoFocus
              />
            </Form.Field>
            <Form.Field>
              <label>
                <FormattedMessage id="login.form.password" />
              </label>
              <Form.Input
                type="password"
                name="password"
                value={password}
                onChange={this._handleInputChanged}
              />
              <Link to="/account/forgot-password" className="clear">
                <FormattedMessage id="login.form.button.forgotPassword" />
              </Link>
            </Form.Field>
            <ErrorMessages error={error} />
            <div className="stacked-buttons">
              <Button type="submit" primary fluid>
                <FormattedMessage id="login.form.button.login" />
              </Button>

              <Divider horizontal>Or</Divider>

              <Button as={Link} to="/account/signup" fluid>
                <FormattedMessage id="login.form.button.signUp" />
              </Button>
            </div>
          </Form>
        </FormWrapper>
        <AppFooter />
        {user && <Redirect to={pathname} />}
      </Wrapper>
    );
  }
}

const mapStateToProps = ({identity, router}) => {
  return {
    user: identity.user,
    state: router.location.state,
    login: login,
    loading: isBusy(login),
    error: getError(login),
  };
};

const LogInWithActions = withActions({login})(LogIn);
export default connect(mapStateToProps)(LogInWithActions);
